import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./Sidebarnew.css";
import api from "../../api/axios";
import { toast } from "react-toastify";

const Sidebarnew = ({
  selectedAgent,
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const [user, setUser] = useState(null);
  const [chatHistory, setChatHistory] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [hoveredChatId, setHoveredChatId] = useState(null);
  const [openMenuId, setOpenMenuId] = useState(null);
  // 👇 WE MOVED THIS TO BE A LOCAL STATE HERE 👇
  const [deleteConfirmGroup, setDeleteConfirmGroup] = useState(null);
  const [showLogoutMenu, setShowLogoutMenu] = useState(false);

  // =========================
  // FETCH USER PROFILE ONLY
  // =========================
  useEffect(() => {
    fetchProfile();
  }, []);

  const fetchProfile = async () => {
    try {
      const res = await api.get("/profile");
      setUser(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  // =========================
  // FETCH CHAT HISTORY FOR SPECIFIC AGENT
  // =========================
  const fetchHistory = async (targetAgentId) => {
    try {
      const res = await api.get(`/agents/${targetAgentId}/conversations?limit=100`);
      const chats = res.data?.conversations || (Array.isArray(res.data) ? res.data : []);
      
     const chatsWithAgentId = chats.map(c => ({
  ...c,
  agent_id: c.agent_id || targetAgentId
}));

      const sorted = chatsWithAgentId.sort(
        (a, b) => new Date(b.created_at) - new Date(a.created_at)
      );
      setChatHistory(sorted);
    } catch (err) {
      console.log(err);
      setChatHistory([]);
    }
  };

  // =========================
  // FETCH ALL RECENT CHATS (GLOBAL)
  // =========================
  const fetchAllRecentChats = async () => {
    try {
      const res = await api.get(`/conversations?limit=200`);
      const chats = res.data?.conversations || (Array.isArray(res.data) ? res.data : []);
      
      const sorted = chats.sort(
        (a, b) => new Date(b.created_at) - new Date(a.created_at)
      );

      
const now = new Date();

const recentChats = sorted.filter((chat) => {

  if (!chat.created_at) return false;

  const chatDate = new Date(chat.created_at);

  if (isNaN(chatDate.getTime())) {
    return false;
  }

  const diffMs = now - chatDate;

  const diffDays =
    diffMs / (1000 * 60 * 60 * 24);

  return diffDays >= 0 && diffDays < 30;
});

      setChatHistory(recentChats);
    } catch (err) {
      console.log(err);
      setChatHistory([]);
    }
  };
  // Add this logout handler function
const handleLogout = async (e) => {
  e.stopPropagation(); // Prevent the click from immediately closing the menu
  try {
    // Call your backend logout route to clear backend sessions/cookies if needed
    await api.get("/auth/logout");
  } catch (err) {
    console.error("Logout error:", err);
  } finally {
    // Clear local JWT tokens or user data here
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    // Redirect to the login page
    navigate("/login"); 
  }
};

  // =========================
  // WATCH FOR ROUTE & AGENT CHANGES
  // =========================
// =========================
  // WATCH FOR ROUTE & AGENT CHANGES
  // =========================
// =========================
  // WATCH FOR ROUTE & AGENT CHANGES
  // =========================
// Replace the entire useEffect block with this:
  useEffect(() => {
    const loadChats = async () => {
      try {
        const currentPath = location.pathname.toLowerCase();

        // 1. If we are in the chat interface, always try to grab the agentId from the URL
        if (currentPath.includes("/chatinterface")) {
          const match = location.pathname.match(/\/chatinterface\/([0-9a-fA-F-]{36})/i);
          const urlAgentId = match?.[1];

          if (urlAgentId) {
            await fetchHistory(urlAgentId);
          }
          return;
        }

        // 2. If we are in new-home (creation flow)
        if (currentPath.includes("/new-home")) {
          if (selectedAgent?.id) {
            await fetchHistory(selectedAgent.id);
          } else {
            setChatHistory([]);
          }
          return;
        }

        // 3. Default: Load global recent chats for everything else
        await fetchAllRecentChats();
      } catch (err) {
        console.error("Sidebar fetch failed:", err);
        setChatHistory([]);
      }
    };

    loadChats();
  }, [location.pathname, selectedAgent?.id]);

  // =========================
  // FILTERED CHATS
  // =========================
  const filteredChats = useMemo(() => {
    if (!searchQuery.trim()) return chatHistory;
    return chatHistory.filter((chat) =>
      chat.question?.toLowerCase().includes(searchQuery.toLowerCase())
    );
  }, [chatHistory, searchQuery]);
  
  // =========================
  // SMART GROUPING LOGIC
  // =========================
  // =========================
  // SMART GROUPING LOGIC
  // =========================
 // =========================
  // SMART GROUPING LOGIC
  // =========================
  const groupedChats = useMemo(() => {
    if (!filteredChats?.length) {
      return { pinned: [], sectionsArray: [] };
    }

    const grouped = {};

    filteredChats.forEach((item) => {
      const key = item.session_id || item.id;
      if (!grouped[key]) {
        grouped[key] = {
          session_id: key,
          items: [],
          groupTime: new Date(item.created_at),
          is_pinned: false
        };
      }
      grouped[key].items.push(item);
      if (item.is_pinned === true) grouped[key].is_pinned = true;

      const itemTime = new Date(item.created_at);
      if (itemTime > grouped[key].groupTime) {
        grouped[key].groupTime = itemTime;
      }
    });

    const sortedGroups = Object.values(grouped).sort(
      (a, b) => b.groupTime - a.groupTime
    );

    const pinned = [];
    const sectionsArray = []; // Using an Array preserves exact chronological order naturally!
    
    const now = new Date();
    now.setHours(0, 0, 0, 0);

    sortedGroups.forEach((group) => {
      if (group.is_pinned) {
        pinned.push(group);
        return;
      }

      const chatDate = new Date(group.groupTime);
      const chatDay = new Date(chatDate);
      chatDay.setHours(0, 0, 0, 0);

      // Calculates exact days ago
      const diffDays = Math.floor((now - chatDay) / (1000 * 60 * 60 * 24));

      let label = "";
      if (diffDays === 0) {
        label = "Today";
      } else if (diffDays === 1) {
        label = "Yesterday";
      } else {
        const day = chatDate.getDate();
        const month = chatDate.toLocaleString("default", { month: "short" });
        label = `${day} ${month}`; // e.g., "15 May"
      }

      // Add to sectionsArray preserving exact chronological order
      let existingSection = sectionsArray.find(sec => sec.label === label);
      if (!existingSection) {
        existingSection = { label, chats: [] };
        sectionsArray.push(existingSection);
      }
      existingSection.chats.push(group);
    });

    return { pinned, sectionsArray };
  }, [filteredChats]);

  // =========================
  // ACTIONS (API CONNECTED)
  // =========================
  const togglePinChat = async (group) => {
    const isPinning = !group.is_pinned;
    try {
      setChatHistory((prev) => 
        prev.map((item) => 
          (item.session_id || item.id) === group.session_id 
            ? { ...item, is_pinned: isPinning }
            : item
        )
      );

      await api.patch(`/conversations/${group.session_id}/pin`, {
        isPinned: isPinning
      });

      toast.success(isPinning ? "Chat pinned!" : "Chat unpinned!", { hideProgressBar: true, autoClose: 2000 });
    } catch (err) {
      console.error(err);
      toast.error("Failed to update pin status");
      if (selectedAgent?.id) fetchHistory(selectedAgent.id); 
    }
  };

  const handleDeleteChat = async (sessionId) => {
    try {
      setChatHistory((prev) =>
        prev.filter((chat) => (chat.session_id || chat.id) !== sessionId)
      );
      setDeleteConfirmGroup(null);

      await api.delete(`/conversations/${sessionId}`);
      toast.success("Chat deleted", { hideProgressBar: true, autoClose: 2000 });
    } catch (err) {
      console.error(err);
      toast.error("Failed to delete chat");
      if (selectedAgent?.id) fetchHistory(selectedAgent.id); 
    }
  };

  useEffect(() => {
    window.handleDeleteChatFromSidebar = handleDeleteChat;
    return () => {
      delete window.handleDeleteChatFromSidebar;
    };
  }, [handleDeleteChat]);

  // =========================
  // NAVIGATION
  // =========================
  const handleNavigate = (path) => navigate(path);
  const handleNewChat = () => navigate("/new-home");
  
  const openChat = (group) => {
    const chat = group.items[0];
    if (chat && chat.agent_id) {
      navigate(`/chatinterface/${chat.agent_id}`, {
        state: { conversationId: chat.session_id || chat.id },
      });
    }
  };

  const userName = user?.name || "Logesh";
  const userInitial = userName.charAt(0).toUpperCase();

 const currentPath = location.pathname.toLowerCase();

const isHome = false;
const isDashboard = currentPath === "/dashboard";

const isKb = currentPath === "/kb";

const isNewChat = currentPath.includes("/new-home");

  // =========================
  // RENDER ROW HELPER
  // =========================
 const renderChatRow = (group, index) => {
    // 1. Get the session ID from the URL if it's there
    const urlParams = new URLSearchParams(location.search);
    const urlSessionId = urlParams.get('conversationId') || location.state?.conversationId;

    // 2. Determine active status:
    // It's active if the URL session matches OR if it's the specific group being viewed
    const isActive = String(group.session_id) === String(urlSessionId) || 
                     String(group.session_id) === String(location.state?.conversationId);

    return (
      <div
        key={index}
        className={`sidebarnew-chat-row ${isActive ? 'active-row' : ''}`}
        onMouseEnter={() => setHoveredChatId(group.session_id)}
        onMouseLeave={() => setHoveredChatId(null)}
      >
        <div
          className={`sidebarnew-chat-item ${isActive ? 'active' : ''}`}
          onClick={() => openChat(group)}
        >
          <img src="/images/chatside.svg" alt="Chat" className="sidebarnew-chat-icon" />
          <p>{group.items?.[0]?.question || "New Conversation"}</p>
          
          {group.is_pinned && (
            <i className="bi bi-pin-angle-fill" style={{color: '#3B82F6', fontSize: '13px', marginLeft: 'auto'}}></i>
          )}
        </div>

        {(hoveredChatId === group.session_id || openMenuId === group.session_id) && (
          <button
            className="sidebarnew-menu-btn"
            onClick={(e) => {
              e.stopPropagation();
              setOpenMenuId(openMenuId === group.session_id ? null : group.session_id);
            }}
          >
            ⋯
          </button>
        )}

        {openMenuId === group.session_id && (
          <div className="sidebarnew-chat-menu">
            <button
              onClick={(e) => {
                e.stopPropagation();
                togglePinChat(group);
                setOpenMenuId(null);
              }}
            >
              {group.is_pinned ? "Unpin Chat" : "Pin Chat"}
            </button>
            <button
              className="delete"
              onClick={(e) => {
                e.stopPropagation();
                setDeleteConfirmGroup(group);
                setOpenMenuId(null);
              }}
            >
              Delete Chat
            </button>
          </div>
        )}
      </div>
    );
  };

  // Ensure sections render in chronological order (Today -> Yesterday -> specific dates -> Older)


 return (
    <div className="sidebarnew">
      {/* ================= LOGO ================= */}
      <div className="sidebarnew-top">
        <div className="sidebarnew-logo-row">
          <div className="sidebarnew-logo-left">
            <img src="/images/Xlogo.svg" alt="logo" className="sidebarnew-logo" />
            <h2>KINEXAR</h2>
          </div>
          {/* <button className="sidebarnew-edit-btn">
            <img src="/images/penside.svg" alt="Edit" />
          </button> */}
        </div>

        {/* ================= SEARCH ================= */}
        <div className="sidebarnew-search">
          <input
            type="text"
            placeholder="Search chats..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>

        {/* ================= NEW CHAT ================= */}
        <button
          className={`sidebarnew-newchat ${isNewChat ? "active" : ""}`}
          onClick={handleNewChat}
        >
          <img src="/images/penside.svg" alt="New Chat" className="sidebarnew-icon" />
          New Chat
        </button>

        {/* ================= NAVIGATION ================= */}
        <div className="sidebarnew-nav">
          <div className={`sidebarnew-nav-item ${isHome ? "active" : ""}`} onClick={() => handleNavigate("/home")}>
            <img src="/images/agside.svg" alt="Agents" className="sidebarnew-icon" />
            Agents
          </div>
          <div className={`sidebarnew-nav-item ${isKb ? "active" : ""}`} onClick={() => handleNavigate("/kb")}>
            <img src="/images/knowside.svg" alt="Knowledge Base" className="sidebarnew-icon" />
            Knowledge Base
          </div>
          <div className={`sidebarnew-nav-item ${isDashboard ? "active" : ""}`} onClick={() => handleNavigate("/dashboard")}>
            <img src="/images/dashside.svg" alt="Dashboard" className="sidebarnew-icon" />
            Dashboard
          </div>
        </div>

        {/* ================= RECENT ================= */}
        <div className="sidebarnew-recent">
          <h4>RECENT</h4>

          {/* PINNED */}
          {groupedChats.pinned.length > 0 && (
            <>
              <p className="sidebarnew-date-heading">Pinned</p>
              {groupedChats.pinned.map((group, index) => renderChatRow(group, index))}
            </>
          )}

          {/* DYNAMIC DATE GROUPS (Today, Yesterday, 12 May, etc.) */}
          {groupedChats.sectionsArray.map((section) => (
            <React.Fragment key={section.label}>
              <p className="sidebarnew-date-heading">{section.label}</p>
              {section.chats.map((group, index) =>
                renderChatRow(group, index)
              )}
            </React.Fragment>
          ))}
        </div>
      </div>

    {/* ================= USER PROFILE ================= */}
     {/* ================= USER PROFILE ================= */}
      <div 
        className="sidebarnew-user" 
        onClick={() => setShowLogoutMenu(!showLogoutMenu)}
      >
        <div className="sidebarnew-avatar">{userInitial}</div>
        <div className="sidebarnew-user-details">
          <h5>{userName}</h5>
          <p>
            {user?.subscription?.planName ||
             user?.planName ||
             "Free Plan"}
          </p>
        </div>

        {/* 👇 BEAUTIFUL LOGOUT MENU 👇 */}
        {showLogoutMenu && (
          <div className="sidebarnew-logout-menu">
            <button className="logout-btn" onClick={handleLogout}>
              Log out
            </button>
          </div>
        )}
      </div>

      {/* 👇 ADDED THE MODAL RIGHT HERE 👇 */}
      {deleteConfirmGroup && (
        <div className="sidebarnew-modal-overlay">
          <div className="sidebarnew-modal-content">
            <h3>Delete Chat</h3>
            <p>Are you sure you want to delete this conversation? This cannot be undone.</p>
            <div className="sidebarnew-modal-actions">
              <button 
                className="cancel-btn" 
                onClick={() => setDeleteConfirmGroup(null)}
              >
                Cancel
              </button>
              <button 
                className="delete-confirm-btn" 
                onClick={() => handleDeleteChat(deleteConfirmGroup.session_id || deleteConfirmGroup.id)}
              >
                Yes, Delete
              </button>
            </div>
          </div>
        </div>
      )}
      {/* 👆 MODAL ENDS HERE 👆 */}

    </div>
  );
};

export default Sidebarnew;